<template>
  <Select
    v-model:value="state.value"
    show-search
    :placeholder="$lang('请输入站点名称/编号查询')"
    style="width: 100%"
    :filter-option="false"
    :not-found-content="state.fetching ? undefined : null"
    :options="state.data"
    :disabled="props.disabled"
    @search="fetchUser"
    @change="changeCode"
    :allowClear="(props.allowClear !== false) && !(props.item?.disabled === false) && !(props.item?.bind?.allowClear === false)"
  >
    <template v-if="state.fetching" #notFoundContent>
      <Spin size="small" />
    </template>
  </Select>
</template>

<script lang="ts" setup>
  import { reactive, watch } from 'vue'
  import { Select, Spin } from 'ant-design-vue'
  import { debounce } from 'lodash-es'
  import siteService from '@/service/api/site'

  interface Props {
    searchParam: Record<string, any>
    item: Record<string, any>
    disabled?: boolean
    allowClear?: boolean
  }

  const props = defineProps<Props>()

  const state = reactive({
    data: [] as Array<Record<string, any>>,
    value: '',
    fetching: false
  })

  const fetchUser = debounce((value: string) => {
    state.data = []
    state.fetching = true
    siteService.dimStation({ param: value }).then((res) => {
      state.fetching = false
      if (res.code === 1) {
        state.data = (res.data || []).map((item: Record<string, any>) => ({
          label: `${item.value} | ${item.key}`,
          value: item.key
        }))
      }
    })
  }, 300)

  const changeCode = (value: string) => {
    props.searchParam[props.item.prop] = value
  }

  watch(
    () => props.searchParam[props.item.prop],
    (value) => {
      state.value = value
      if (props.item.selectDic) {
        state.data = props.item.selectDic
      }
    },
    {
      immediate: true,
      deep: true
    }
  )

  watch(
    () => state.value,
    () => {
      state.data = []
    }
  )
</script>
